<template>
  <div style="background: #dbdbdb">
    <section class="personal-center" ref="personalCenter">
      <span class="sidebarbutton">
        <nav
          id="navbar"
          class="navbar navbar-expand-md navbar-light"
          style="font-color:#0082BA;font-size: 16px; font-weight: bold; max-width: 1440px; margin: auto;"
        >
          <button
            class="toggler-icon btn btn-info"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="toggleSidebar"
          >
            <span class="navbar-toggler-icon"></span> Action Menu
            <i class="fa fa-sort-desc fa-2x" aria-hidden="true"></i>
          </button>
        </nav>
      </span>

      <div class="wrapper">
        <nav id="sidebar" :class="{active}">
          <div class="userimg lightbluebg" style="background: #d92638; padding: 18px 0 18px 16px;">
            <!-- <img src="./Bitmap2.jpg"> -->
            <img :src="userImg" intrinsicsize="52 x 52" />
            <span class="p-3">{{employer.name}}</span>
          </div>
          <ul class="personal-center__nav-list">
            <router-link
              @click.native="setActive"
              to="/personalCenter/myLoan/loanLists"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.meta.name === 'myLoan' ? 'active' : '']"
            >My Loans</router-link>
            <router-link v-if="this.appliedProductName != 'SBRE_product'"
              @click.native="setActive"
              to="/personalCenter/BusinessInfo"
              tag="li"
              :class="['personal-center__nav-list-item--business', $route.meta.name === 'business' ? 'active' : '']"
            >Business Info</router-link>
            <!--ç¾Žå›½ä¿¡ç”¨  PCç«¯ï¼ŒåŽ»æŽ‰ çº¢è‰²åœˆä½�éƒ¨åˆ†ï¼šä¸ªäººä¿¡æ�¯ ã€� é“¶è¡Œå�¡ ã€�å®žå��è®¤è¯�-->
            <!--2018/4/14 by hgwn-->
            <router-link v-if="this.appliedProductName != 'SBRE_product'"
              @click.native="setActive"
              to="/personalCenter/myInfo/PersonInfo"
              tag="li"
              :class="['personal-center__nav-list-item--my-info', $route.meta.name === 'myInfo' ? 'active' : '']"
            >Personal Details</router-link>

            <router-link v-if="this.appliedProductName == 'SBRE_product'"
              @click.native="setActive"
              to="/personalCenter/updateLoan?type=realEstate"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.query === 'updateLoan' ? 'active' : '']"
            >Application Detail</router-link>
            <!--class="personal-center__nav-list-item&#45;&#45;my-info">-->
              <!--<span v-if="Number(userInfo.crmCustomerType) === 1">
              Personal Details
              </span>-->
              <!--<span v-if="Number(userInfo.crmCustomerType) === 2">ä¼�ä¸šä¿¡æ�¯</span>-->
            
            <!-- <router-link
              @click.native="setActive"
              :to="{}"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.meta.name === 'linkYourBank' ? 'active' : '']"
            >LINK YOUR BANK</router-link> -->

            <!-- <li class="personal-center__nav-list-item--bankcard-info">Link Your Bank</li> -->

            <router-link v-if="this.appliedProductName == 'SBEL_product'"
              @click.native="setActive"
              to="/personalCenter/updateEquipment?type=equipment"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.query === 'updateEquipment' ? 'active' : '']"
            >Equipment Details</router-link>

            <router-link v-if="this.appliedProductName == 'SBIF_product'"
              @click.native="setActive"
              to="/personalCenter/updateBilling?type=billing"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan', $route.query === 'updateBilling' ? 'active' : '']"
            >Financial Details</router-link>

            <router-link v-if="this.appliedProductName == 'SB2M_product'"
              @click.native="setActive"
              to="/personalCenter/updateBilling?type=property"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan']"
            >Property Details</router-link>

            <!-- <router-link
              @click.native="setActive"
              :to="{ path: updateApplicationLink, query: { type: 'equipment' } }"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan']"
            >Equipment Details</router-link>

            <router-link
              @click.native="setActive"
              :to="{ path: updateApplicationLink, query: { type: 'billing' } }"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan']"
            >Billing Details</router-link> -->

            <router-link
              @click.native="setActive"
              to="/personalCenter/file-upload"
              tag="li"
              :class="['personal-center__nav-list-item--file-uploading', $route.query === 'updateBilling' ? 'active' : '']"
              >File Upload</router-link>

            <!-- <router-link
              @click.native="setActive"
              :to="{ path: updateApplicationLink, query: { type: 'paycheck' } }"
              tag="li"
              :class="['personal-center__nav-list-item--my-loan']"
            >PPP DOCUMENTS</router-link> -->

            <router-link
              @click.native="setActive"
              to="/personalCenter/updatePassword"
              tag="li"
              :class="['personal-center__nav-list-item--update-password', $route.query === 'updateBilling' ? 'active' : '']"
            >Reset Password</router-link>
            <!-- <router-link
              :to="{ path: '/apply', query: { email: this.email } }"
              tag="li"
              class="personal-center__nav-list-item--my-loan"
            >Need A Loan</router-link> -->
            <li @click="startApply" class="personal-center__nav-list-item--my-loan">Need A Loan</li>
            <!-- <li @click="gotoApply()" class="personal-center__nav-list-item--my-loan">NEED A LOAN</li> -->
            <li @click="logout" class="personal-center__nav-list-item--my-info">Log Out</li>
          </ul>
        </nav>
        <router-view class="personal-center__router-view"></router-view>
      </div>
    </section>
    <div class="row">
      <div class="col-lg-2 col-sm-0 p-3"></div>
        <div class="col-lg-5 col-sm-8 p-3">
          <el-dialog title="notice" :visible.sync="centerDialogVisible" center>
            <span>Are you sure you want to log out?</span>
            <span slot="footer" >
              <el-button @click="centerDialogVisible = false">Cancel</el-button>
              <el-button type="primary" @click="confirmLogout">OK</el-button>
            </span>
          </el-dialog>
        </div>
      <div class="col-lg-2 col-sm-1 p-3"></div>
    </div>

    <el-dialog
      class="contract-dialog"
      top="5%"
      title="Declaration"
      :visible.sync="showAgreementDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleDialogClose"
    >
      <span slot="title"><img
        :src="require('../assets/imgs/American Credit_logo_TM_a.png')"
        class="img-fluid logo"
        alt="American Credit Logo"
      /></span>
      <div v-if="showSignDeclarationWarning"><h4 style="color:red; text-align: center;">Please sign declaration file first.</h4></div>
      <div class="contract__dialog-body agreement_contract declaration__dialog-body">
        <img :src="readContract" alt="read" />
      </div>
      <div slot="footer" class="dialog__footer">
        <el-button
          v-if="signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="showSignAgreement"
          style="margin-right:30px;"
        >{{signBtn.text}}</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn sign_btn"
          :disabled="signBtn.state"
          @click="downAgreement2"
          style="margin-right:30px;"
        >Download Declaration</el-button>
        <el-button
          v-if="!signBtn.isShow"
          class="dialog__footer__confirm-btn continue_btn"
          :disabled="signBtn.state"
          @click="hideAgreement"
          style="margin-right:30px;"
        >Continue Application</el-button>
        <!--<a :href="downAgreement" class="down_agreen" download="contract">Download Contract</a>-->
      </div>
    </el-dialog>

    <el-dialog
      class="showSignDialog"
      title="Please type in your full name to sign the declaration digitally"
      :visible.sync="showSignDialog"
    >
      <el-form>
        <el-form-item>
          <el-input
            placeholder="Please input your full name to sign"
            v-model="fullName"
            auto-complete="off"
            @change="allowSubmit"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSignDialog = false">Cancel</el-button>
        <el-button type="primary" @click="signAgreement" :disabled="allowSubmitBut">Sign</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="showSignDialog"
      title="Please select which loan you would like to apply"
      :visible.sync="showSelectLoanDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form>
        <el-form-item>
          <el-select v-model="loan" v-on:change="onLoanChange" placeholder="Select loan to apply" class="select_loan_width">
            <el-option
              v-for="item in loanS"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSelectLoanDialog = false">Cancel</el-button>
        <el-button type="primary" @click="continueApply" :disabled="allowApplyBut">Apply</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      email: "",
      active: "",
      screenHeight: document.body.clientHeight,
      userImg: "",
      userName: "",
      centerDialogVisible: false,
      declarationId: 10000058500118,
      showSignDeclarationWarning: false,
      showAgreementDialog: false,
      showSignDialog: false,
      fullName: "",
      allowSubmitBut: true,
      signBtn: {
        state: false,
        text: "Sign Declaration",
        isShow: true
      },
      showSelectLoanDialog: false,
      allowApplyBut: true,
      loan: "",
      loanS: [
        { value: "Equipment Finance", text: "Equipment Finance" },
        { value: "Working Capital Term Loan", text: "Working Capital Term Loan" },
        { value: "Real Estate Loan", text: "Real Estate Loan" },
        { value: "2nd Mortgage Loan", text: "2nd Mortgage Loan" }
      ],
      employer: {
        name: ""
      },
      linkYourBankLink: `/applyLoan/${localStorage.getItem("$applyId")}/sbl2`,
      updateApplicationLink: `/applyLoan/${localStorage.getItem("$applyId")}/update`,
      appliedProductName: ''
    };
  },
  computed: {
    ...mapGetters({
      companyInfo: types.GET_COMPANY_INFO,
      userInfo: types.GET_USER,
      products: types.GET_HOT_PRODUCTS,
      readDeclaration: types.GET_DECLARATION_IMAGE_SRC
    }),

    readContract() {
      return `${this.readDeclaration}01&loanItemContractId=${this.declarationId}`;
    }
  },
  mounted() {
    // this.$msgbox("Due to high application volume at our portal, you are recommended to complete all business information, business owner personal details, and equipment/billing details so that we could have a prompt review of your loan application. Incomplete application cannot be reviewed. Follow-up communications on incomplete application cost time and resources, delaying your access to capital.", "Attention");

    this.getPersonalInitData({
      token: this.userInfo.token
    })
    .then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        if(data.declarationId == null || data.declarationId == 10000058500118) {
          this.showAgreementDialog = true;
        } else {
          this.declarationId = data.declarationId;
        }
        if(data.frontApply != null) {
          this.appliedProductName = data.frontApply.frontApplyProductName
        }
      }
      this.userImg = res.data.result.customerPhoto
        ? "/mingdao/platform/system/sysFile/getFileById.ht?fileId=" +
          res.data.result.customerPhoto
        : require("../assets/imgs/user.png");
      this.userName = res.data.result.customerName;
      this.email = res.data.result.email;
      this.employer = {
        name: res.data.result.employer.name
      };

    })
    .catch(err => {
      console.log("getPersonalInitData error");
    });
  },
  methods: {
    ...mapMutations({
      //      companyInfo: types.GET_COMPANY_INFO,
      setActiveName: types.SET_ACTIVE_NAME,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE
    }),
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA,
      userLogout: types.USER_LOGOUT,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),

    allowSubmit(val) {
      if (this.fullName != "") {
        this.allowSubmitBut = false;
      } else {
        this.allowSubmitBut = true;
      }
    },

    onLoanChange() {
      if (this.loan != "") {
        this.allowApplyBut = false;
      } else {
        this.allowApplyBut = true;
      }
    },

    continueApply() {
      if(this.loan === "Equipment Finance") {
        this.$router.push({ path: '/apply', query: { email: this.email } });
      }
      if(this.loan === "Working Capital Term Loan") {
        this.$router.push({ path: '/apply-term-loan', query: { email: this.email } });
      }
      if(this.loan === "Real Estate Loan") {
        this.$router.push({ path: '/apply-real-estate', query: { email: this.email } });
      }
      if(this.loan === "2nd Mortgage Loan") {
        this.$router.push({ path: '/apply-2nd-mortgage', query: { email: this.email } });
      }
    },

    startApply() {
      this.showSelectLoanDialog = true;
    },

    showAgreement() {
      this.showAgreementDialog = true;
    },

    hideAgreement() {
      this.showAgreementDialog = false;
    },

    showSignAgreement() {
      this.showSignDialog = true;
    },

    signAgreement() {
      const _this = this;
      var fullName = this.fullName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: this.userInfo.token,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          if (data.code === 0) {
            _this.setSuccessModal({
              show: true,
              content: data.msg
            });
            this.showSignDialog = false;
            this.declarationId = data.result;
            this.signBtn.isShow = false;
            this.signBtn.state = false;
            this.signBtn.text = "Signed";
            this.showSignDeclarationWarning = false;
          } else if (data.code === 1) {
            this.setFailModal({
              show: true,
              content: data.msg
            });
          }
        });
    },
    downAgreement2() {
      window.open(
        `/mingdao/mobile/item/pdfSignatureController/readDeclaration.ht?download=true&fileType=PDF&identify=01&loanItemContractId=${this.declarationId}`
      );
    },

    setActive() {
      this.setActiveName("2");
      this.closeSidebar();
    },
    logout() {
      this.closeSidebar();
      this.centerDialogVisible = true;
    },
    confirmLogout() {
      this.centerDialogVisible = false;
      this.userLogout({
        router: this.$router
      });
    },
    gotoApply() {
      this.closeSidebar();
      this.$router.push(`/applyLoan/10000058380010/sbl`);
      // api
      //   .get("/mobile/item/loanItemFrontApply/mgxyIsCanApply.ht", {
      //     tokenId: this.userInfo.token,
      //     customerId: this.userInfo.crmCustomerId
      //   })
      //   .then(res => {
      //     if (res.data.code == 0) {
      //       this.$router.push(`/applyLoan/10000058380010/sbl`);
      //     } else if (res.data.code == 1) {
      //       this.$alert(res.data.msg);
      //     }
      //   });
    },
    showSidebar() {
      this.active = "";
    },
    toggleSidebar() {
      if (this.active == "active") {
        this.active = "";
      } else {
        this.active = "active";
      }
    },
    closeSidebar() {
      this.active = "";
    },
    handleDialogClose(done) {
      if(this.declarationId == null || this.declarationId == 10000058500118) {
        this.showSignDeclarationWarning = true;
      } else {
        done();
      }
    }
  }
};
</script>


<style scoped lang="scss">
@import "../assets/css/style.css";

.select_loan_width {
  width: 80%;
}

.personal-center-container {
  margin-bottom: 40px;
  .userimg {
    background: #2ecc71;
    width: 100%;
    box-sizing: border-box;
    padding: 18px 0 18px 16px;
    img {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
      font-size: 14px;
    }
  }
}

@mixin personalCenterNavLi {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: "FZLanTingHei-DB-GBK";

  &:before {
    content: "";
    display: inline-block;
    margin: 0 10px 0 10px;
    vertical-align: -8px;
    width: 28px;
    height: 28px;
  }

  &.active {
    background: #243342;
  }
}

.personal-center-container {
  background: #f5f7f8;
}

.personal-center {
  @include clear;
  position: relative;
  margin: 0 auto;
  padding-top: 20px;
  /*min-height: 648px;*/
  background: #dbdbdb;
  max-width: 1440px;
}

.personal-center__nav {
  margin-top: 20px;
  @include clear;
  float: left;
  position: absolute;
  width: 250px;
  height: 96%;
  color: $white;
  background: #34495e;
}

.personal-center__nav-list {
  padding: 20px 0;
  li:hover {
    cursor: pointer;
  }
}

.personal-center__nav-list-item--my-loan {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_money.png") no-repeat;
  }
}

.personal-center__nav-list-item--business {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_id_card.png") no-repeat;
  }
}

.personal-center__nav-list-item--my-info {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_user.png") no-repeat;
  }
}

.personal-center__nav-list-item--bankcard-info {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_bankcard.png") no-repeat;
  }
}

.personal-center__nav-list-item--file-uploading {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_upload.png") no-repeat;
  }
}

.personal-center__nav-list-item--real-name-auth {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_id_card.png") no-repeat;
  }
}

.personal-center__nav-list-item--update-password {
  @include personalCenterNavLi;
  &:before {
    background: url("#{$imagePath}/icons/icon_gear.png") no-repeat;
  }
}

.personal-center__router-view {
  height: 100%;
  //   min-height:600px;
}
</style>





// WEBPACK FOOTER //
// PersonalCenter.vue?080f336d